import React from 'react';
import Icon from '../../../components/AppIcon';

const AuditTrail = ({ data }) => {
  const getActionIcon = (action) => {
    const actionMap = {
      'Manual Adjustment': 'Edit',
      'Reconciliation Override': 'CheckCircle',
      'Payment Retry': 'RefreshCw',
      'Export': 'Download'
    };
    return actionMap?.[action] || 'FileText';
  };

  const getApprovalBadge = (status) => {
    const statusMap = {
      Approved: { color: 'bg-success/10 text-success', icon: 'CheckCircle' },
      Pending: { color: 'bg-warning/10 text-warning', icon: 'Clock' },
      Rejected: { color: 'bg-error/10 text-error', icon: 'XCircle' }
    };
    return statusMap?.[status] || statusMap?.Pending;
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
            Audit Trail
          </h3>
          <p className="text-sm text-muted-foreground">
            Complete transaction history with user attribution
          </p>
        </div>
        <button className="flex items-center gap-2 px-4 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors duration-250">
          <Icon name="Download" size={18} />
          <span className="text-sm font-medium">Export</span>
        </button>
      </div>
      <div className="space-y-3 max-h-96 overflow-y-auto custom-scrollbar">
        {data?.map((entry) => {
          const approvalBadge = getApprovalBadge(entry?.approvalStatus);
          return (
            <div key={entry?.id} className="bg-muted/50 rounded-lg p-4 border-l-4 border-primary">
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name={getActionIcon(entry?.action)} size={20} color="var(--color-primary)" />
                  </div>
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-sm font-semibold text-foreground">{entry?.action}</span>
                      <span className={`text-xs px-2 py-1 rounded-full ${approvalBadge?.color} flex items-center gap-1`}>
                        <Icon name={approvalBadge?.icon} size={10} />
                        {entry?.approvalStatus}
                      </span>
                    </div>
                    <div className="text-sm text-muted-foreground mb-2">{entry?.description}</div>
                    <div className="flex items-center gap-4 text-xs text-muted-foreground">
                      <span className="flex items-center gap-1">
                        <Icon name="User" size={12} />
                        {entry?.user} ({entry?.userRole})
                      </span>
                      <span className="flex items-center gap-1">
                        <Icon name="Clock" size={12} />
                        {entry?.timestamp}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {entry?.previousValue && entry?.newValue && (
                <div className="bg-card rounded-lg p-3 flex items-center justify-between text-xs">
                  <div>
                    <span className="text-muted-foreground">Previous: </span>
                    <span className="font-medium text-foreground">{entry?.previousValue}</span>
                  </div>
                  <Icon name="ArrowRight" size={14} color="var(--color-muted-foreground)" />
                  <div>
                    <span className="text-muted-foreground">New: </span>
                    <span className="font-medium text-foreground">{entry?.newValue}</span>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AuditTrail;